interface CustomerInfoProps {
  name: string;
  phone: string;
  pickupDateTime: string;
}

export default function CustomerInfo({ name, phone, pickupDateTime }: CustomerInfoProps) {
  // ISO string을 한국어 형식으로 변환
  const formatPickupTime = (isoString: string) => {
    const date = new Date(isoString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    return date.toLocaleString('ko-KR', options);
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-3">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">예약 정보</h3>

      <div className="space-y-2">
        <div className="flex items-start gap-3">
          <span className="text-sm text-gray-600 min-w-[60px]">고객명</span>
          <span className="text-sm font-medium text-gray-900">{name}</span>
        </div>

        <div className="flex items-start gap-3">
          <span className="text-sm text-gray-600 min-w-[60px]">연락처</span>
          <span className="text-sm font-medium text-gray-900">{phone}</span>
        </div>

        <div className="flex items-start gap-3">
          <span className="text-sm text-gray-600 min-w-[60px]">픽업 예정</span>
          <span className="text-sm font-medium text-gray-900">{formatPickupTime(pickupDateTime)}</span>
        </div>
      </div>
    </div>
  );
}
